import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import EmailRotationEngine from "./EmailRotationEngine";

export default function EmailsTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ subject: "", body: "", audience_tag: "" });

  const load = async () => { const r = await api.get("/campaigns"); setItems(r.data.campaigns); };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    await api.post("/campaigns", form); toast.success("Campaign saved");
    setForm({ subject: "", body: "", audience_tag: "" }); load();
  };
  const send = async (id) => { const r = await api.post(`/campaigns/${id}/send`); toast.success(`${r.data.simulated ? "Simulated: " : ""}Sent to ${r.data.sent} contacts`); load(); };

  return (
    <div className="space-y-10" data-testid="emails-tab">
      {/* HERO: 104-Email Rotation Engine — main asset */}
      <EmailRotationEngine />

      {/* SECONDARY: One-off broadcasts */}
      <div className="border-t border-border/50 pt-8">
        <div className="text-xs tracking-wider-cap text-gold-deep">One-Off Broadcasts</div>
        <h2 className="text-3xl uppercase text-red-wine">Reach Your Flock</h2>
        <p className="text-sm text-foreground/80 mt-1">Send a custom message right now to your contact list. Use this for special announcements that don't fit the weekly rotation.</p>
      </div>
      <form onSubmit={save} className="faith-card p-6 space-y-4" data-testid="campaign-form">
        <input required placeholder="Subject" className="w-full px-4 py-3 rounded-md border border-border bg-white" value={form.subject} onChange={e=>setForm({...form, subject:e.target.value})} data-testid="campaign-subject"/>
        <textarea required rows={6} placeholder="Write your message (HTML allowed)…" className="w-full px-4 py-3 rounded-md border border-border bg-white" value={form.body} onChange={e=>setForm({...form, body:e.target.value})} data-testid="campaign-body"/>
        <input placeholder="Audience tag (optional, e.g. 'homeschool')" className="w-full px-4 py-3 rounded-md border border-border bg-white" value={form.audience_tag} onChange={e=>setForm({...form, audience_tag:e.target.value})} data-testid="campaign-tag"/>
        <button className="btn-primary" data-testid="campaign-save">Save Campaign</button>
      </form>
      <div>
        <h3 className="text-2xl uppercase text-red-wine mb-3">Your Campaigns</h3>
        {items.length === 0 ? <p className="text-foreground">No campaigns yet.</p> : (
          <div className="space-y-3">
            {items.map(c => (
              <div key={c.id} className="faith-card p-5 flex items-center justify-between" data-testid={`campaign-${c.id}`}>
                <div>
                  <div className="font-semibold">{c.subject}</div>
                  <div className="text-xs text-foreground">{c.status} · sent to {c.sent_count} {c.audience_tag ? `· tag: ${c.audience_tag}`:""}</div>
                </div>
                {c.status !== "sent" && <button onClick={() => send(c.id)} className="btn-gold !py-2 !px-3 !text-sm" data-testid={`send-${c.id}`}>Send</button>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
